import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ReportOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"report_off"}/>
}
